import Swiper, {
	Navigation,
	Pagination,
	SwiperOptions
} from 'swiper';
import {isBrowserIE} from '../helper/ie11';

export function initSliders() {

	if (isBrowserIE()) {

		const sliderContainer: NodeList | null = <NodeList>document.querySelectorAll('.swiper-container');
		const sliderWrapper: NodeList | null = <NodeList>document.querySelectorAll('.swiper-wrapper');
		const sliderSlider: NodeList | null = <NodeList>document.querySelectorAll('.swiper-slide');
		const sliderNavigation: NodeList | null = <NodeList>document.querySelectorAll('.swiper-button');
		const sliderPagination: NodeList | null = <NodeList>document.querySelectorAll('.swiper-pagination');

		Array.prototype.forEach.call(sliderContainer, (item: HTMLAnchorElement) => {
			item.classList.remove('swiper-container');
		});
		Array.prototype.forEach.call(sliderWrapper, (item: HTMLAnchorElement) => {
			item.classList.remove('swiper-wrapper');
		});
		Array.prototype.forEach.call(sliderSlider, (item: HTMLAnchorElement) => {
			item.classList.remove('swiper-slide');
		});
		Array.prototype.forEach.call(sliderNavigation, (item: HTMLAnchorElement) => {
			item.remove()
		});
		Array.prototype.forEach.call(sliderPagination, (item: HTMLAnchorElement) => {
			item.remove()
		});
	} else {
		Swiper.use([Navigation, Pagination]);

		initSwiper('[data-slider]', {
			spaceBetween: 30,
			loop: false,
			autoHeight: true,
			slidesPerView: 1,
			breakpoints: {
				600: {
					slidesPerView: 2
				}
			}
		});

		initSwiper('[data-slider-images]', {
			loop: false,
			autoHeight: true,
			slidesPerView: 1
		});

	}
}

/**
 * Initializes a new swiper instance for each slider on the page.
 *
 * @param {string} selector
 * @param {SwiperOptions} options - pass customized options except for `pagination` and `navigation`, those will be overridden
 */
function initSwiper(selector: string, options: SwiperOptions) {
	const sliders: NodeList = <NodeList>document.querySelectorAll(selector);

	Array.prototype.forEach.call(sliders, (slider: HTMLElement) => {
		const nextEl: HTMLElement = <HTMLElement>slider.parentElement.querySelector('.swiper-button-next');
		const prevEl: HTMLElement = <HTMLElement>slider.parentElement.querySelector('.swiper-button-prev');
		const pagination: HTMLElement = <HTMLElement>slider.parentElement.parentElement.querySelector('.swiper-pagination');

		new Swiper(slider, Object.assign(options, {
			pagination: {
				el: pagination,
				clickable: true
			},
			navigation: {
				nextEl: nextEl,
				prevEl: prevEl
			}
		}));
	});
}




